import {styled} from "@mui/material/styles"

export const SlideWrapper = styled("div")`
    display: flex;
    align-items: center;
    height: 100%;
    width: 100%;
    position: relative;
`
export const SlideItem = styled("div", {
    shouldForwardProp: prop => !["hidden", "next"].includes(prop as any),
})<{hidden: boolean; next: boolean}>`
    position: absolute;
    left: 0;
    width: 100%;
    height: 2.25rem;
    transition: transform 0.5s ease-in-out, opacity 0.5s ease-in-out;
    opacity: ${(props: {hidden}) => (props.hidden ? 0 : 1)};
    transform: ${(props: {hidden; next}) => () => {
        let value = "translateY(0)"
        if (props.hidden) value = "translateY(-36px)"
        if (props.next) value = "translateY(36px)"
        return value
    }};
    @supports (-webkit-touch-callout: none) {
        top: 0;
    }
`

export const MainWrapper = styled("div")`
    width: 100%;
    height: 2.25rem;
    position: relative;
`
export const SlideContent = styled("div")`
    width: 100%;
    height: 100%;
`
